<template>
  <div class="content-item flex">
    <div class="content-item-label">摘要</div>
    <el-input
      type="textarea"
      show-word-limit
      :rows="6"
      resize="none"
      maxlength="120"
      class="item-input"
      v-model="input"
      placeholder="请输入内容"
    ></el-input>
  </div>
</template>

<script>
export default {
  name: "summary",
  props: ["summary"],
  computed: {
    input: {
      get() {
        return this.summary;
      },
      set(val) {
        this.$emit("update:summary", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-textarea__inner) {
  resize: none;
  overflow: hidden;
  overflow-y: auto;
  display: inline-block;
  margin-right: 15px;
  min-height: 130px !important;
}
</style>
